import { HelpOutline } from '@mui/icons-material';
import { Box, IconButton, Popover, Tooltip, styled } from '@mui/material';
import { useState, MouseEvent } from 'react';
import { FailureSubjectKind } from '@/hooks/api/assets/useGetAssetFailureDiagnostics';
import { useGetFailureDiagnosticsAvailability } from '@/hooks/api/assets/useGetFailureDiagnosticsAvailability';
import { FailureDiagnostics } from './FailureDiagnostics';

const WhyButton = styled(IconButton)({
  flexShrink: 0,
  padding: '2px',
});

const PopoverBody = styled(Box)({
  // Wide enough that a 36 character trace id stays on one line next to its label and copy button.
  width: '430px',
  padding: '4px',
});

export const FailureWhyButton = ({
  assetId,
  assetName,
  kind,
}: {
  assetId: string;
  assetName: string;
  kind?: FailureSubjectKind;
}) => {
  const [anchor, setAnchor] = useState<HTMLElement | undefined>();
  const { data: availability } = useGetFailureDiagnosticsAvailability();

  const open = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchor(event.currentTarget);
  };

  if (!availability?.available) return;

  return (
    <>
      <Tooltip title={`Why did ${assetName} fail?`} followCursor enterDelay={0} enterTouchDelay={0}>
        <WhyButton size='small' color='secondary' onClick={open} aria-label={`Why did ${assetName} fail?`}>
          <HelpOutline sx={{ fontSize: '1rem' }} />
        </WhyButton>
      </Tooltip>
      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(undefined)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        onClick={event => event.stopPropagation()}
      >
        <PopoverBody>{!!anchor && <FailureDiagnostics assetId={assetId} kind={kind} />}</PopoverBody>
      </Popover>
    </>
  );
};
